import React, { ReactElement } from 'react';
import { Modal } from '@odin-labs/components';
import { TrashIcon } from 'components/icons';
import { DeleteJobsiteFormModalProps } from './types';

export function DeleteJobsiteFormModal(
  props: DeleteJobsiteFormModalProps,
): ReactElement {
  const { isOpen, onCancel, onConfirm, jobsiteForm } = props;

  const onAction = (): void => {
    onConfirm?.(jobsiteForm);
  };

  return (
    <Modal
      open={isOpen}
      setOpen={onCancel}
      size="xs"
      variant="drawer"
      title={`Delete "${jobsiteForm?.form?.label}" Log?`}
      titleAlignment="center"
      textAlignment="center"
      onAction={onAction}
      actionText="Delete Log"
      actionButtonTheme="danger"
      actionIcon={TrashIcon}
    />
  );
}
